import apolloClient from "../../../../shared/utilities/graphql/apolloClient";

export default {
  query: apolloClient.query
};
